<script>
import axios from "axios";
import avatarImage from "@/assets/img/avatar.jpg";

export default {
  name: "AuthenticatedProfileImage",
  inheritAttrs: false,
  props: {
    size: { type: [Number, String], default: 100 },
    alt: { type: String, default: "Profile" },
  },
  data: () => ({ source: avatarImage, objectUrl: null }),
  async mounted() {
    await this.loadProfileImage();
  },
  beforeUnmount() {
    this.releaseObjectUrl();
  },
  methods: {
    releaseObjectUrl() {
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    },
    async loadProfileImage() {
      try {
        const listResponse = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/file-upload/documents`
        );
        const profile = (listResponse.data?.data || []).find(
          (document) => document.documentType === "profile_image"
        );
        if (!profile?.contentUrl) return;

        const imageResponse = await axios.get(profile.contentUrl, {
          responseType: "blob",
        });
        this.releaseObjectUrl();
        this.objectUrl = URL.createObjectURL(imageResponse.data);
        this.source = this.objectUrl;
      } catch (_error) {
        this.source = avatarImage;
      }
    },
    useFallback() {
      this.releaseObjectUrl();
      this.source = avatarImage;
    },
  },
};
</script>

<template>
  <img
    v-bind="$attrs"
    :src="source"
    :alt="alt"
    :width="size"
    :height="size"
    class="profile-image"
    @error="useFallback"
  />
</template>

<style scoped>
.profile-image {
  object-fit: cover;
}
</style>
